import { Box, Tab, Tabs } from '@mui/material';
import { DraftIcon } from 'components/CustomIcons';
import React, { useCallback } from 'react';
import { useSelector } from 'store/hooks';
import { useAppState } from 'store/Provider';
import { changeCurrentTabAction, gethelpMenuAPIAction } from '../../../store/actions/helpmenuActions';
import { HelpMenuTableType } from '../../../types/enums/HelpMenuTableType';

const HelpMenuTabs: React.FC = () => {
  const { state, dispatch } = useAppState();
  const currentTab = useSelector((state) => state.helpMenu.currentTab);
  const parentAPiCall = useSelector((state) => state.helpMenu.helpMenuApiFlag);
  const currentTabs = useCallback(
    () => [
      {
        label: HelpMenuTableType.VIDEOS,
        value: HelpMenuTableType.VIDEOS,
      },
      {
        label: HelpMenuTableType.USER_GUIDE,
        value: HelpMenuTableType.USER_GUIDE,
      },
    ],
    []
  );

  const handleTabChange = (value: HelpMenuTableType) => {
    dispatch(gethelpMenuAPIAction(!parentAPiCall));
    dispatch(changeCurrentTabAction(value));
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 4 }}>
      {currentTab && (
        <Tabs value={currentTab}>
          {currentTabs().map((tab) => (
            <Tab
              key={tab?.label}
              data-testid={`helpmenu_tab_${tab.value}`}
              label={tab.label}
              value={tab.value}
              iconPosition="start"
              onClick={() => handleTabChange(tab.value)}
              disabled={state.helpMenu.currentTab === tab.value}
            />
          ))}
        </Tabs>
      )}
    </Box>
  );
};

export default HelpMenuTabs;
